import { Toaster } from "@utils/toast";
import { FC } from "react";
import AuthInitializer from "./components/AuthInitializer";
import AppRoutes from "./routes";

const App: FC = () => {
  return (
    <>
      <AuthInitializer />
      <Toaster />
      <AppRoutes />
    </>
  );
};

export default App;
